// extracted by mini-css-extract-plugin
module.exports = {"IAndCArchiveServices":"IAndCArchiveServices_IAndCArchiveServices__28ntE"};